const map = {
	"./CambridgeResult.webp": 8516,
	"./CertGitGithub.jpg": 2413,
	"./CertHtmlCSS.jpg": 9516,
	"./CertificadoExcel.jpg": 9320,
	"./cicd.svg": 7619,
	"./cloud.svg": 9669,
	"./css.svg": 51,
	"./curriculo.jpg": 664,
	"./docker.svg": 7938,
	"./dominos.png": 1545,
	"./excel.svg": 895,
	"./fastapi.svg": 4120,
	"./git.svg": 7630,
	"./github-icon.png": 2935,
	"./githubactions.svg": 1224,
	"./gmail-icon.png": 4708,
	"./graphql.svg": 5541,
	"./html.svg": 6237,
	"./ibm.png": 6136,
	"./icatu.png": 1226,
	"./javascript.svg": 8595,
	"./linkedin-icon.png": 8182,
	"./mongodb.svg": 8124,
	"./mysql.svg": 4488,
	"./nodejs.svg": 6439,
	"./nova-foto.jpg": 7171,
	"./nova-foto2.png": 9217,
	"./postgresql.svg": 3064,
	"./postman.svg": 6560,
	"./projects/divtrack.webp": 8066,
	"./projects/djs-best-friend.webp": 4919,
	"./projects/frenchlingo.webp": 7361,
	"./projects/tcc-capa.png": 301,
	"./python.svg": 532,
	"./react.svg": 1959,
	"./seidor.png": 7464,
	"./sql.svg": 3498,
	"./swagger.svg": 5954,
	"./vue.svg": 7542,
	"./whatsapp-icon.png": 6254
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;